var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index py-5"},[_c('div',{staticClass:"form-container"},[_c('AveineUserList',{attrs:{"APIbaseURL":_vm.APIbaseURL}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }